import apiBackendClient from "../utils/apiBackendClient";

import { MINT_STAGES_OPEN } from "../constants";

const getMintStagesOpen = () => apiBackendClient.get(MINT_STAGES_OPEN);

const methods = { getMintStagesOpen };

export default methods;
